// FoodModal.jsx
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/thumbs";
import "swiper/css/free-mode";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation } from "swiper";
import OrderCartUpdate from "../OrderCartUpdate/OrderCartUpdate";
import loadingImg from "./../../../../Assets/Image/LoadingSpin.gif";
import { Skeleton } from "antd";
import OrderCart from "../../../OrderPage/OrderCart/OrderCart";
import "./FoodModalUpdate.css";
import dineIn from "../../../../Assets/Icons/DineIn.png";
import recommendations from "../../../../Assets/Icons/customer.png";
import delivery from "../../../../Assets/Icons/delivery-bike-circle2.png";
import clock from "../../../../Assets/Icons/clock.png";
import OutOfHourModal from "../../../../components/OutOfHourModal/OutOfHourModal";
import { toast, ToastContainer } from "react-toastify";
import axios from "axios";
import LeoImg from "../../../../Assets/Image/Leo.png";
import Rating from "react-rating";
import FoodItem from "../../../../components/FoodModal/FoodItem";
import { formatInitialSelectionsFromBackend } from "../../../../components/FoodModal/foodItemLogic";

const FoodModalUpdate = ({
  show,
  handleClose,
  orderDetails,
  selectedItemImage,
  selectedItemId,
  cart,
  setCart,
  loading,
  openingFrom = "",
}) => {
  const [tabView, setTabView] = useState(1);
  // const selectedItemInCart = cart?.find((item) =>
  //   item.itemDetails.some((detail) => detail.itemId === selectedItemId)
  // );

  console.log("________", orderDetails, selectedItemId);

  const [toggleDelivery, setToggleDelivery] = useState(false);
  const [dineInClickable, setDineInClickable] = useState(false);
  const [deliveryClickable, setDeliveryClickable] = useState(false);
  const [orderType, setOrderType] = useState("");
  const [menuType, setMenuType] = useState("");
  const [hasUserInteracted, setHasUserInteracted] = useState(false);

  // See more and See Less functionality
  const [isExpanded, setIsExpanded] = useState(false);
  const [isExpandedStory, setIsExpandedStory] = useState(false);
  const [isExpandedDetails, setIsExpandedDetails] = useState(false);
  const [isExpandedInstruction, setIsExpandedInstruction] = useState(false);

  const [detailsId, setDetailsId] = useState(null);
  const seeFullDetails = (id) => {
    setDetailsId(id);
  };

  const toggleDescription = (tabsName) => {
    switch (tabsName) {
      case "description":
        setIsExpanded(!isExpanded);
        break;
      case "details":
        setIsExpandedDetails(!isExpandedDetails);
        break;
      case "story":
        setIsExpandedStory(!isExpandedStory);
        break;
      case "instruction":
        setIsExpandedInstruction(!isExpandedInstruction);
        break;
    }
  };

  const [instructionId, setInstructionId] = useState(null);
  const seeFullInstruction = (id) => {
    setInstructionId(id);
  };

  console.log("order details from add: ", orderDetails);

  const findFoodItem = (cartData, foodItemId) => {
    for (const cart of cartData) {
      for (const subOrder of cart.subOrders) {
        console.log("toggleed: ", subOrder);
        const foodItem = subOrder.itemDetails.find(
          (item) => item.foodItemId === foodItemId
        );
        if (foodItem) {
          return {
            orderType: subOrder.orderTypeName,
            foodItem,
          };
        }
      }
    }

    return null;
  };

  const selectedItemInCart = findFoodItem(cart, selectedItemId);

  console.log("food item clicked data: ", selectedItemInCart?.foodItem);

  useEffect(() => {
    if (!selectedItemInCart || hasUserInteracted) return;

    setMenuType(selectedItemInCart.orderType);

    if (selectedItemInCart.orderType === "In-Store") {
      setToggleDelivery(false);
      setOrderType("Dine-In");
    } else if (selectedItemInCart.orderType === "Delivery") {
      setToggleDelivery(true);
      setOrderType("Collection");
    }
  }, [selectedItemInCart, hasUserInteracted]);
  // }, [selectedItemInCart]);

  // useEffect(() => {
  const updateCartStatus = async () => {
    if (orderType) {
      if (orderType !== (menuType === "In-Store" ? "Dine-In" : "Collection")) {
        setMenuType(orderType === "Dine-In" ? "In-Store" : "Delivery");

        console.log("selectedItemInCart", selectedItemInCart);
        console.log("cart", cart);

        try {
          const response = await axios.get(
            `${
              process.env.REACT_APP_SECRET
            }/api/Cart/UpdateCartStatus?suborderId=${
              selectedItemInCart.foodItem.subOrderId
            }&status=${
              orderType === "Dine-In" ? "In-Store" : "Delivery"
            }&itemId=${selectedItemInCart.foodItem.cartItemId}&orderId=${
              selectedItemInCart.foodItem.orderId
            }`
          );
          // toast.success(response.data);
        } catch (error) {
          console.error(error.response?.data || "Error updating cart");
        }
      }
    }
  };

  //   updateCartStatus();
  // }, [orderType]);

  useEffect(() => {
    if (!orderDetails?.menuType) return;

    const menuTypes = orderDetails.menuType
      .split(",")
      .map((type) => type.trim());

    if (menuTypes.includes("In-Store") && !menuTypes.includes("Delivery")) {
      // Only "In-Store" is available
      setDineInClickable(true);
      setDeliveryClickable(false);
    } else if (
      menuTypes.includes("Delivery") &&
      !menuTypes.includes("In-Store")
    ) {
      // Only "Delivery" is available
      if (orderDetails.isDelivery) {
        setDineInClickable(false);
        setDeliveryClickable(true);
      } else {
        toast.warning(
          "Delivery toggle cannot be false if menu type is Delivery!"
        );
        setDineInClickable(false);
        setDeliveryClickable(false);
      }
    } else if (
      menuTypes.includes("In-Store") &&
      menuTypes.includes("Delivery")
    ) {
      // Both options are available
      if (orderDetails.isDelivery) {
        setDineInClickable(true);
        setDeliveryClickable(true);
        setToggleDelivery(true);
        // setOrderType("0DEB06FD-2D9D-49EA-8E17-44E2958E1056");
        setOrderType("7CD55767-82AF-4912-AA5B-DCCBB9CCC68A");
        // setSelectedDelivery("dine-in");
      } else {
        setToggleDelivery(false);
        setDineInClickable(true);
        setDeliveryClickable(false);
        setOrderType("0DEB06FD-2D9D-49EA-8E17-44E2958E1056");
        // setOrderType("7CD55767-82AF-4912-AA5B-DCCBB9CCC68A");
        // setSelectedDelivery("dine-in");
      }
      // // Both options are available
      // setDineInClickable(true);
      // setDeliveryClickable(true);
    } else {
      // Neither option is available
      setDineInClickable(false);
      setDeliveryClickable(false);
    }
  }, [orderDetails]);

  const [showOutOfHourModal, setShowOutOfHourModal] = useState(false);

  const handleShowScheduleModal = () => {
    setShowOutOfHourModal(true);
  };

  const DineInGotClicked = () => {
    if (dineInClickable) {
      setHasUserInteracted(true);
      if (orderType !== "Dine-In") {
        setToggleDelivery(false);
        setOrderType("Dine-In");
        toast.info("Switched to Dine-In");
      }
    }
  };

  const DeliveryGotClicked = () => {
    if (deliveryClickable) {
      setHasUserInteracted(true);
      if (orderType !== "Collection") {
        setToggleDelivery(true);
        setOrderType("Collection");
        toast.info("Switched to Delivery");
      }

      // if (
      //   orderDetails?.isDelivery &&
      //   !orderDetails?.isCollectionOnly
      // ) {
      //   if (orderType !== "Collection") {
      //     toast.info("Switched to Delivery");
      //   }
      // } else if (orderDetails?.isCollectionOnly) {
      //   toast.info("Switched to Collection");
      // }
    }
  };
  console.log("ForderDetails", orderDetails);

  const [expandedDetailIds, setExpandedDetailIds] = useState([]);
  const [expandedInstructionIds, setExpandedInstructionIds] = useState([]);

  const toggleDetailDescription = (index) => {
    setExpandedDetailIds((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };

  const toggleInstructionDescription = (index) => {
    setExpandedInstructionIds((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };
console.log("food item clicked data: ", selectedItemInCart?.foodItem);
  return (
    <Modal show={show} onHide={handleClose} className='modal-xl '>
      <ToastContainer />
      <Modal.Body style={{ padding: "0px", borderRadius: "10px" }}>
        {orderDetails != null ? (
          <>
            <button
              type='button'
              className='btn-close btn-modal'
              onClick={handleClose}
            ></button>
            <div className='update-modal-main-container bg-black foodModalParent'>
              {/* Image Section */}
              <div className='updateModalImageContainer d-flex justify-content-center galleryModalImgDiv  '>
                <Swiper
                  spaceBetween={2}
                  grabCursor={false}
                  centeredSlides={false}
                  slidesPerView={"auto"}
                  cssMode={true}
                  pagination={{
                    dynamicBullets: true,
                  }}
                  navigation={true}
                  modules={[Pagination, Navigation]}
                  className='foodCart h-100 '
                  // initialSlide={selectedIndex}
                >
                  {orderDetails.foodItemImages?.length > 0 ? (
                    orderDetails.foodItemImages?.map((d, index) => {
                      return (
                        <SwiperSlide key={d.itemImagePath}>
                          <img
                            src={d.itemImagePath}
                            className='img-fluid '
                            alt={d.description}

                            // onClick={props.onClickInsideTest3}
                          />
                        </SwiperSlide>
                      );
                    })
                  ) : selectedItemImage ? (
                    <SwiperSlide key={"selectedItemImage"}>
                      <img
                        src={selectedItemImage}
                        className='img-fluid'
                        alt='...'
                        // onClick={props.onClickInsideTest3}
                      />
                    </SwiperSlide>
                  ) : (
                    <SwiperSlide key='loading'>
                      <img
                        src={loadingImg}
                        className='img-fluid h-10'
                        alt='...'
                        style={{
                          height: "5rem !important",
                          objectFit: "contain",
                        }}
                        // onClick={props.onClickInsideTest3}
                      />
                    </SwiperSlide>
                  )}
                </Swiper>
              </div>

              {/* Details Section */}
              <div className='updateModalDetailsContainer bg-white foodModalRight'>
                <div className='card' style={{ border: "0px" }}>
                  <div className='card-body  '>
                    <h3 style={{ color: "#3D1E19" }}>
                      <strong>{orderDetails?.itemName || <Skeleton />}</strong>
                      <span className='text-muted ms-2'>
                        £{orderDetails?.itemBasePrice}
                      </span>
                    </h3>

                    {/* Fooditem ratings, Restaurant Name, restaurant rating */}
                    <span className='ratingspan ms-0'>
                      <Rating
                        className='ratingStar'
                        initialRating={Number(4.5)}
                        emptySymbol='far fa-star icon-color'
                        fullSymbol='fas fa-star icon-color'
                        readonly
                      ></Rating>
                      4.5
                    </span>

                    {openingFrom === "searchResult" ||
                      (openingFrom === "cartDetails" && (
                        <div
                          className='d-flex resrating my-2'
                          data-bs-toggle='modal'
                          data-bs-target='#staticBackdrop'
                        >
                          <span className='d-flex gap-1 align-items-center'>
                            <img
                              src={orderDetails?.restaurantLogo}
                              style={{
                                width: "20px",
                                height: "20px",
                                borderRadius: "10px",
                              }}
                            />
                            <h6
                              className='resnamerating m-0'
                              style={{ color: "#3D1E19" }}
                            >
                              {orderDetails?.name}
                            </h6>
                          </span>
                          <span
                            className='ratingspan'
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <Rating
                              className='ratingStar'
                              initialRating={Number(4.5)}
                              emptySymbol='far fa-star icon-color'
                              fullSymbol='fas fa-star icon-color'
                              readonly
                              start={0}
                              stop={1}
                            ></Rating>
                            4.5
                          </span>
                        </div>
                      ))}

                    <p className='my-1 text-muted'>
                      {orderDetails?.description}{" "}
                    </p>
                    {/* <div className='d-flex justify-content-between align-items-center'>
                      <div className='d-flex align-items-center'>
                        <img
                          src={selectedItemImage?.restaurantLogo}
                          className='me-1 userImg'
                          alt=''
                        />
                        <h6>{selectedItemImage?.name}</h6>
                      </div>

                      <button className="follow-BUtton btn ms-1">Follow</button>
                    </div> */}

                    {/* Leo Review Section */}
                    <div className='d-flex align-items-center my-2'>
                      <img src={LeoImg} className='me-1 userImg' alt='' />
                      <p className='my-1 text-muted small'>
                        No available review for this item yet
                      </p>
                    </div>
                    <hr className='mb-0' />
                  </div>
                </div>

                {/* Schedule - Dine-In - Collection - Recommend */}
                <div className='d-flex align-items-center justify-content-around'>
                  <div
                    className='cart-modal-icon-container update-cart-modal-icon-container'
                    onClick={handleShowScheduleModal}
                    title='Schedule'
                  >
                    <div className='cart-modal-icon'>
                      <img src={clock} alt='schedule icon' />
                    </div>
                    <div className='cart-modal-icon-title'>Schedule</div>
                  </div>

                  <hr className='horizontal-line' />

                  {/* Dine-In Selection */}
                  <div
                    className={`cart-modal-icon-container ${
                      !toggleDelivery && dineInClickable
                        ? "cart-modal-icon-selected"
                        : ""
                    } ${!dineInClickable ? "cart-modal-icon-disabled" : ""}`}
                    title='Dine-In'
                    onClick={DineInGotClicked}
                  >
                    <div className='cart-modal-icon'>
                      <img src={dineIn} alt='dine-in icon' />
                    </div>
                    <div className='cart-modal-icon-title'>Dine-In</div>
                  </div>

                  <hr className='horizontal-line' />

                  {/* Delivery / Collection -- Selection */}
                  <div
                    className={`cart-modal-icon-container ${
                      toggleDelivery && deliveryClickable
                        ? "cart-modal-icon-selected"
                        : ""
                    } 
                    ${!deliveryClickable ? "cart-modal-icon-disabled" : ""}`}
                    title='Delivery'
                    onClick={DeliveryGotClicked}
                  >
                    <div className='cart-modal-icon deliveryiconimg delivery-icon-container'>
                      <img src={delivery} alt='delivery icon' />
                    </div>
                    <div className='cart-modal-icon-title'>
                      {orderDetails?.isDelivery &&
                      orderDetails?.isCollectionOnly
                        ? "Collection"
                        : "Delivery"}
                    </div>
                  </div>

                  <hr className='horizontal-line' />

                  {/* Recommendation */}
                  <div
                    className='cart-modal-icon-container update-cart-modal-icon-container'
                    title='Recommendation'
                  >
                    <div className='cart-modal-icon'>
                      <img src={recommendations} alt='recommendation icon' />
                    </div>
                    <div className='cart-modal-icon-title'>Recommend</div>
                  </div>
                </div>

                {orderDetails != null ? (
                  <>
                    <div className='col-12'>
                      <div className=''>
                        <div className='col-12 pt-2 d-flex justify-content-between distanceBottom'>
                          <button
                            data-mdb-ripple-color='dark'
                            type='button'
                            className={` dsrButton ${
                              tabView === 1 ? "onselecteddsrButton" : ""
                            }`}
                            onClick={() => {
                              setTabView(1);
                            }}
                          >
                            Details
                          </button>
                          <button
                            data-mdb-ripple-color='dark'
                            type='button'
                            className={` dsrButton ${
                              tabView === 2 ? "onselecteddsrButton" : ""
                            }`}
                            onClick={() => {
                              setTabView(2);
                            }}
                          >
                            Story
                          </button>
                          <button
                            data-mdb-ripple-color='dark'
                            type='button'
                            className={` dsrButton ${
                              tabView === 3 ? "onselecteddsrButton" : ""
                            }`}
                            onClick={() => {
                              setTabView(3);
                            }}
                          >
                            Instructions
                          </button>
                        </div>
                      </div>
                      <div className=' orderCartRow'>
                        <div className='col-12 d-flex justify-content-center'>
                          <div className='col-12 d-flex justify-content-center'>
                            <div className='card OrderfoodcardDetailsParagraph my-1 p-2  paragraph card-design'>
                              {/* {orderDetails != null && (
                                <>
                                  {tabView === 1 ? (
                                    <>
                                      <div
                                        style={{
                                          display: "-webkit-box",
                                          WebkitBoxOrient: "vertical",
                                          overflow: "hidden",
                                          WebkitLineClamp: isExpandedDetails
                                            ? "unset"
                                            : 4,
                                        }}
                                      >
                                        {orderDetails.foodItemDetailList.map(
                                          (dt, i) => (
                                            <>
                                              <h6
                                                style={{
                                                  fontWeight: "bold",
                                                  marginBottom: "0px",
                                                  fontSize: "1rem",
                                                }}
                                              >
                                                {dt.details}
                                              </h6>
                                              {dt?.description?.length > 100 &&
                                                detailsId !== i ? (
                                                <p
                                                  className="small-font m-0"
                                                  key={i}
                                                >
                                                  {dt.description.substring(
                                                    0,
                                                    50
                                                  )}
                                                  {" . . . "}

                                                  <button
                                                    onClick={() =>
                                                      seeFullDetails(i)
                                                    }
                                                    className="seeMoreButton btn p-1"
                                                  >
                                                    See more
                                                  </button>
                                                </p>
                                              ) : detailsId === i ? (
                                                <p
                                                  className="small-font mb-0"
                                                  key={i}
                                                >
                                                  {dt.description}
                                                  <button
                                                    onClick={() =>
                                                      seeFullDetails(null)
                                                    }
                                                    className="seeMoreButton btn p-1"
                                                  >
                                                    See less
                                                  </button>
                                                </p>
                                              ) : (
                                                <p
                                                  className="small-font mb-0"
                                                  key={i}
                                                >
                                                  {dt.description}
                                                </p>
                                              )}
                                            </>
                                          )
                                        )}
                                      </div>
                                    </>
                                  ) : tabView === 2 ? (
                                    // Story with see more button
                                    <>
                                      <p
                                        className="small-font m-0"
                                        style={{
                                          display: "-webkit-box",
                                          WebkitBoxOrient: "vertical",
                                          overflow: "hidden",
                                          WebkitLineClamp: isExpandedStory
                                            ? "unset"
                                            : 3,
                                        }}
                                      >
                                        {isExpandedStory &&
                                          orderDetails?.foodItemStory.story}

                                        {!isExpandedStory &&
                                          orderDetails.foodItemStory.story.substring(
                                            0,
                                            50
                                          ) + "..."}

                                        {orderDetails?.foodItemStory?.story
                                          ?.length > 160 && (
                                            <button
                                              className="seeMoreButton btn p-0"
                                              onClick={() =>
                                                toggleDescription("story")
                                              }
                                            >
                                              {isExpandedStory
                                                ? "See less"
                                                : "See more"}
                                            </button>
                                          )}
                                      </p>
                                    </>
                                  ) : (
                                    // Instruction with see more button
                                    <>
                                      <div
                                        style={{
                                          display: "-webkit-box",
                                          WebkitBoxOrient: "vertical",
                                          overflow: "hidden",
                                          WebkitLineClamp: isExpandedInstruction
                                            ? "unset"
                                            : 6,
                                        }}
                                      >
                                        {orderDetails.foodItemInstructionList.map(
                                          (dt, i) => (
                                            <>
                                              <div key={i}>
                                                <h6
                                                  style={{
                                                    fontWeight: "bold",
                                                    marginBottom: "0px",
                                                    fontSize: "1rem",
                                                  }}
                                                >
                                                  {dt.name}
                                                </h6>
                                                {dt?.description?.length > 80 &&
                                                  instructionId !== i ? (
                                                  <p
                                                    className="small-font mb-0"
                                                    key={i}
                                                  >
                                                    {dt.description.substring(
                                                      0,
                                                      70
                                                    )}
                                                    {"..."}

                                                    <button
                                                      onClick={() =>
                                                        seeFullInstruction(i)
                                                      }
                                                      className="seeMoreButton btn p-1"
                                                    >
                                                      See more
                                                    </button>
                                                  </p>
                                                ) : instructionId === i ? (
                                                  <p
                                                    className="small-font mb-0"
                                                    key={i}
                                                  >
                                                    {dt.description}
                                                    <button
                                                      onClick={() =>
                                                        seeFullInstruction(null)
                                                      }
                                                      className="seeMoreButton btn p-1"
                                                    >
                                                      See less
                                                    </button>
                                                  </p>
                                                ) : (
                                                  <p
                                                    className="small-font mb-0"
                                                    key={i}
                                                  >
                                                    {dt.description}
                                                  </p>
                                                )}
                                              </div>
                                            </>
                                          )
                                        )}
                                      </div>
                                      {orderDetails?.foodItemInstructionList
                                        ?.length > 1 && (
                                          <button
                                            className="seeMoreButton btn p-0"
                                            onClick={() =>
                                              toggleDescription("instruction")
                                            }
                                          >
                                            {isExpandedInstruction
                                              ? "See less"
                                              : "See more"}
                                          </button>
                                        )}
                                    </>
                                  )}
                                </>
                              )} */}

                              {orderDetails && (
                                <>
                                  {/* ---------- Tab 1: Details ---------- */}
                                  {tabView === 1 && (
                                    <>
                                      {!orderDetails.foodItemDetailList ||
                                      orderDetails.foodItemDetailList.length ===
                                        0 ? (
                                        <p className='small-font'>
                                          Details not found
                                        </p>
                                      ) : (
                                        <>
                                          <div
                                            style={{
                                              display: "-webkit-box",
                                              WebkitBoxOrient: "vertical",
                                              overflow: "hidden",
                                              WebkitLineClamp: isExpandedDetails
                                                ? "unset"
                                                : 6,
                                            }}
                                          >
                                            {(isExpandedDetails
                                              ? orderDetails.foodItemDetailList
                                              : orderDetails.foodItemDetailList.slice(
                                                  0,
                                                  1
                                                )
                                            ).map((dt, i) => (
                                              <div key={i}>
                                                <h6
                                                  style={{
                                                    fontWeight: "bold",
                                                    marginBottom: "0px",
                                                    fontSize: "1rem",
                                                  }}
                                                >
                                                  {dt.details?.trim()
                                                    ? dt.details
                                                    : "No Details found"}
                                                </h6>

                                                {dt.description?.trim() ? (
                                                  expandedDetailIds.includes(
                                                    i
                                                  ) ? (
                                                    <p className='small-font mb-0'>
                                                      {dt.description}
                                                      <button
                                                        onClick={() =>
                                                          toggleDetailDescription(
                                                            i
                                                          )
                                                        }
                                                        className='seeMoreButton btn p-1'
                                                      >
                                                        See less
                                                      </button>
                                                    </p>
                                                  ) : dt.description.length >
                                                    80 ? (
                                                    <p className='small-font mb-0'>
                                                      {dt.description.substring(
                                                        0,
                                                        60
                                                      )}{" "}
                                                      ...
                                                      <button
                                                        onClick={() =>
                                                          toggleDetailDescription(
                                                            i
                                                          )
                                                        }
                                                        className='seeMoreButton btn p-1'
                                                      >
                                                        See more
                                                      </button>
                                                    </p>
                                                  ) : (
                                                    <p className='small-font mb-0'>
                                                      {dt.description}
                                                    </p>
                                                  )
                                                ) : (
                                                  <p className='small-font mb-0'>
                                                    No description found
                                                  </p>
                                                )}
                                              </div>
                                            ))}
                                          </div>

                                          {orderDetails.foodItemDetailList
                                            .length > 1 && (
                                            <button
                                              className='seeMoreButton btn p-0'
                                              onClick={() =>
                                                toggleDescription("details")
                                              }
                                            >
                                              {isExpandedDetails
                                                ? "See less"
                                                : "See more"}
                                            </button>
                                          )}
                                        </>
                                      )}
                                    </>
                                  )}

                                  {/* ---------- Tab 2: Story ---------- */}
                                  {tabView === 2 && (
                                    <p
                                      className='small-font m-0'
                                      style={{
                                        display: "-webkit-box",
                                        WebkitBoxOrient: "vertical",
                                        overflow: "hidden",
                                        WebkitLineClamp: isExpandedStory
                                          ? "unset"
                                          : 3,
                                      }}
                                    >
                                      {orderDetails.foodItemStory?.story?.trim()
                                        ? isExpandedStory
                                          ? orderDetails.foodItemStory.story
                                          : orderDetails.foodItemStory.story
                                              .length > 60
                                          ? `${orderDetails.foodItemStory.story.substring(
                                              0,
                                              60
                                            )} ... `
                                          : orderDetails.foodItemStory.story
                                        : "No Story found"}

                                      {orderDetails.foodItemStory?.story
                                        ?.length > 160 && (
                                        <button
                                          className='seeMoreButton btn p-0'
                                          onClick={() =>
                                            toggleDescription("story")
                                          }
                                        >
                                          {isExpandedStory
                                            ? " See less"
                                            : " See more"}
                                        </button>
                                      )}
                                    </p>
                                  )}

                                  {/* ---------- Tab 3: Instruction ---------- */}
                                  {tabView === 3 && (
                                    <>
                                      {!orderDetails.foodItemInstructionList ||
                                      orderDetails.foodItemInstructionList
                                        .length === 0 ? (
                                        <p className='small-font'>
                                          Instruction Details not found
                                        </p>
                                      ) : (
                                        <>
                                          <div
                                            style={{
                                              display: "-webkit-box",
                                              WebkitBoxOrient: "vertical",
                                              overflow: "hidden",
                                              WebkitLineClamp:
                                                isExpandedInstruction
                                                  ? "unset"
                                                  : 6,
                                            }}
                                          >
                                            {(isExpandedInstruction
                                              ? orderDetails.foodItemInstructionList
                                              : orderDetails.foodItemInstructionList.slice(
                                                  0,
                                                  1
                                                )
                                            ).map((dt, i) => (
                                              <div key={i}>
                                                <h6
                                                  style={{
                                                    fontWeight: "bold",
                                                    marginBottom: "0px",
                                                    fontSize: "1rem",
                                                  }}
                                                >
                                                  {dt.name?.trim()
                                                    ? dt.name
                                                    : "No Title"}
                                                </h6>

                                                {dt?.description?.trim() ? (
                                                  expandedInstructionIds.includes(
                                                    i
                                                  ) ? (
                                                    <p className='small-font mb-0'>
                                                      {dt.description}
                                                      <button
                                                        onClick={() =>
                                                          toggleInstructionDescription(
                                                            i
                                                          )
                                                        }
                                                        className='seeMoreButton btn p-1'
                                                      >
                                                        See less
                                                      </button>
                                                    </p>
                                                  ) : dt.description.length >
                                                    80 ? (
                                                    <p className='small-font mb-0'>
                                                      {dt.description.substring(
                                                        0,
                                                        60
                                                      )}{" "}
                                                      ...
                                                      <button
                                                        onClick={() =>
                                                          toggleInstructionDescription(
                                                            i
                                                          )
                                                        }
                                                        className='seeMoreButton btn p-1'
                                                      >
                                                        See more
                                                      </button>
                                                    </p>
                                                  ) : (
                                                    <p className='small-font mb-0'>
                                                      {dt.description}
                                                    </p>
                                                  )
                                                ) : (
                                                  <p className='small-font mb-0'>
                                                    No description found
                                                  </p>
                                                )}
                                              </div>
                                            ))}
                                          </div>

                                          {orderDetails.foodItemInstructionList
                                            .length > 1 && (
                                            <button
                                              className='seeMoreButton btn p-0'
                                              onClick={() =>
                                                toggleDescription("instruction")
                                              }
                                            >
                                              {isExpandedInstruction
                                                ? "See less"
                                                : "See more"}
                                            </button>
                                          )}
                                        </>
                                      )}
                                    </>
                                  )}
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                        <br></br>
                      </div>
                      {/* mobileDisplay end */}
                    </div>

                    {/* <OrderCartUpdate
                      updateCartStatus={updateCartStatus}
                      handleClose={handleClose}
                      orderDetails={orderDetails}
                      from={"modal"}
                      itemId={selectedItemId}
                      selectedItem={selectedItemImage}
                      selectedItemInCart={selectedItemInCart}
                      cart={cart}
                    /> */}
                    <FoodItem
                      mode='edit'
                      food={orderDetails}
                      handleClose={handleClose}
                      orderType={orderType}
                       selectedItemInCart={selectedItemInCart}
                      initialSelections={formatInitialSelectionsFromBackend(
                        selectedItemInCart?.foodItem
                      )}
                    />
                  </>
                ) : (
                  <img
                    src={loadingImg}
                    className='img-fluid h-10'
                    alt='...'
                    style={{
                      height: "5rem !important",
                      objectFit: "contain",
                    }}
                    // onClick={props.onClickInsideTest3}
                  />
                )}

                {showOutOfHourModal && (
                  <OutOfHourModal
                    setShowOutOfHourModal={setShowOutOfHourModal}
                    foodItemName={orderDetails.itemName}
                  />
                )}
              </div>
            </div>
          </>
        ) : (
          // <div className='d-flex justify-content-center'>
          //   <div>
          //     <img
          //       src={loadingImg}
          //       className='img-fluid h-10'
          //       alt='...'
          //       style={{
          //         height: '5rem !important',
          //         objectFit: 'contain',
          //       }}
          //       // onClick={props.onClickInsideTest3}
          //     />
          //   </div>
          // </div>
          <div className='d-flex justify-content-center'>
            <div className='w-100'>
              <Skeleton.Image
                className='img-fluid w-100'
                style={{
                  height: "300px",
                }}
              />

              <div className='card' style={{ border: "0px" }}>
                <div className='card-body'>
                  <h3 style={{ color: "#3D1E19" }}>
                    <Skeleton active />
                  </h3>
                  <p className='my-1 text-muted'>
                    <Skeleton active />
                  </p>
                  <div className='d-flex justify-content-between align-items-center'>
                    <div className='d-flex align-items-center'>
                      <Skeleton.Avatar className='me-1' active />
                      <h6>
                        <Skeleton active />
                      </h6>
                    </div>
                  </div>
                  <hr className='mb-0' />
                </div>
              </div>
              <div style={{ marginTop: "20px" }}>
                <Skeleton active paragraph={{ rows: 3 }} />
              </div>
            </div>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default FoodModalUpdate;
